export default "__VITE_ASSET__67ec7150__"